(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mitoCardSpotlightBound) return;
    window.__mitoCardSpotlightBound = true;
    document.addEventListener('pointermove', function (event) {
      var gallery = event.target && event.target.closest ? event.target.closest('.card-gallery') : null;
      if (!gallery) return;
      var rect = gallery.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      gallery.style.setProperty('--spot-x', x + '%');
      gallery.style.setProperty('--spot-y', y + '%');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
